const menuItemsArabic = [
    { to: '/', label: 'الصفحة الرئيسية' },
    { to: '/about-us', label: 'عن شركه سبل الاعمال' },
    { to: '/services', label: 'خدماتنا' },
    { to: '/contact-us', label: 'إتصل بنا' }
]

export { menuItemsArabic }